module.exports = __webpack_public_path__ + "media/images/home-banner-6f2e666e0319b07430f1094b56d58021.jpg";